import type { ReactNode } from 'react';

/**
 * What a list shows when it has nothing.
 *
 * Saying *why* it is empty and what to do next, rather than leaving a blank
 * rectangle that reads the same as a page that failed to load.
 */
export function EmptyState({
  title,
  children,
  action,
}: {
  title: string;
  children: ReactNode;
  action?: ReactNode;
}): ReactNode {
  return (
    <div className="empty">
      <h3>{title}</h3>
      <p className="muted text-sm">{children}</p>
      {action !== undefined && <div className="row">{action}</div>}
    </div>
  );
}
